var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26905",
    "data-name": "Group 26905",
    transform: "translate(-10222 8438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6239",
    "data-name": "Rectangle 6239",
    transform: "translate(10222 -8438)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_417",
    "data-name": "Union 417",
    d: "M-18,1148.15A8.159,8.159,0,0,1-9.85,1140,8.159,8.159,0,0,1-1.7,1148.15a8.159,8.159,0,0,1-8.149,8.15A8.16,8.16,0,0,1-18,1148.15Zm3.445-4.705a6.609,6.609,0,0,0-1.945,4.705,6.607,6.607,0,0,0,1.945,4.705A6.607,6.607,0,0,0-9.85,1154.8a6.605,6.605,0,0,0,4.7-1.945A6.607,6.607,0,0,0-3.2,1148.15a6.609,6.609,0,0,0-1.945-4.705,6.609,6.609,0,0,0-4.7-1.945A6.611,6.611,0,0,0-14.555,1143.445Zm4.183,9.285a.738.738,0,0,1-.22-.53v-4.4a.75.75,0,0,1,.738-.759h.012a.748.748,0,0,1,.53.22.757.757,0,0,1,.22.542v4.4a.75.75,0,0,1-.75.75A.741.741,0,0,1-10.372,1152.73Zm-.419-7.921a.952.952,0,0,1,.95-.95.952.952,0,0,1,.95.95.951.951,0,0,1-.95.949A.951.951,0,0,1-10.791,1144.809Z",
    transform: "translate(10243.85 -9574.15)",
    fill: "#1171d9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBlue);
export default __webpack_public_path__ + "static/media/infoIconBlue.98c178c1e3b379442eb776dbdefd0d2d.svg";
export { ForwardRef as ReactComponent };